import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { loginSuccess } from '../store/actions';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import { MdCall } from 'react-icons/md';
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

function BasicExample(props) {

  const { user } = props;

  useEffect(() => {
    getUser();
  }, [])

  const getUser = async () => {
    var data = localStorage.getItem('authUser');
    const user = JSON.parse(data);
    console.log('all user data', user);
    props?.loginSuccess(user);
  }

  return (
    <>
      <div className='top-strip-section'>
        <ul>
          <li><span>For employer</span><a href="tel:7982993471;"><MdCall /> 7982993471</a></li>
          <li><span>For candidate</span><a href="tel:9650703757;"><MdCall /> 9650703757</a></li>
          <li><span>For candidate</span><a href="mailTo:virendravats.hr@gmail.com;"><MdEmail /> virendravats.hr@gmail.com</a></li>
        </ul>
        <ul className='icon_list'>
          <li><a href="https://www.facebook.com/apprenticeshipwale" target='_blank'><FaFacebookF /></a></li>
          <li><a href="https://www.instagram.com/apprenticeshipwale/" target='_blank'><FaInstagram /></a></li>
          <li><a href="https://www.linkedin.com/company/apprenticeshipwale" target='_blank'><FaLinkedinIn /></a></li>
        </ul>
      </div>
      <Navbar bg="light" className='navbar-section' expand="lg">
        <Container fluid>
          <Navbar.Brand href="/">
            <div className='logo_box'>
              <img src={require('../assets/images/logo.png')} alt="logo" />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <div className='main-menu'>

              <div className='top-maenu'>
                <ul>
                  <li> <img src={require('../assets/images/affiliations/3.png')} alt="c-1" /></li>
                  <li> <img src={require('../assets/images/affiliations/4.png')} alt="c-1" /></li>
                  <li> <img src={require('../assets/images/affiliations/6.png')} alt="c-1" /></li>
                </ul>
                {
                  user ?
                    <div className='top-btn-group'>
                      {/* <Link to="/quick-registration" className='log-btn'>
                        Register
                      </Link> */}
                      <button className='log-btn'>
                        <Link to='/logout'>
                          Logout
                        </Link>
                      </button>
                    </div>
                    :
                    <div className='top-btn-group'>
                      {/* <Link to="/quick-registration" className='log-btn'>
                        Register
                      </Link> */}
                      <button className='log-btn'>
                        <Link to='/login'>
                          Login or Signup
                        </Link>
                      </button>
                    </div>
                }
              </div>

              <Nav className="second-menu-list">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/job-listing">Opportunities</Nav.Link>
                {/* <Nav.Link href="/service">Services</Nav.Link> */}
                {/* <Nav.Link href="/faq">FAQ’s</Nav.Link> */}
                <Nav.Link href="/about">About</Nav.Link>
                <Nav.Link href="/contact">Contact</Nav.Link>
                {/* <Nav.Link href="/blog-list">Blog</Nav.Link> */}
                {/* <Nav.Link href="#link" className='submenu'>Usefull Links</Nav.Link> */}

                <NavDropdownMenu title="Usefull Links" id="collasible-nav-dropdown" className='dropdown_menu' alignLeft>
                  <NavDropdown.Item href="https://www.youtube.com/watch?v=EWto9YJ-3Ws&feature=youtu.be" target="_blank" className='sub_menu'> Introduction to Apprenticeship Portal </NavDropdown.Item>
                  <NavDropdown.Item href="https://www.youtube.com/watch?v=8_rKnGtk474&feature=youtu.be" target="_blank">Registration</NavDropdown.Item>
                  <NavDropdown.Item href="https://www.youtube.com/watch?v=9yTwtCSZkmc&feature=youtu.be" target="_blank">Profile Completion</NavDropdown.Item>
                  <NavDropdown.Item href="https://www.youtube.com/watch?v=GNKCR68Z-rg&feature=youtu.be" target="_blank">Opportunities</NavDropdown.Item>
                  <NavDropdown.Item href="https://www.youtube.com/watch?v=8J26cDyidIU&feature=youtu.be" target="_blank">Contract</NavDropdown.Item>
                </NavDropdownMenu>
                <NavDropdownMenu title="Usefull Websites Links" id="collasible-nav-dropdown" className='dropdown_menu' alignLeft>
                  <NavDropdown.Item href="https://www.apprenticeshipindia.gov.in/" target="_blank">apprenticeshipindia</NavDropdown.Item>
                  <NavDropdown.Item href="https://portal.mhrdnats.gov.in/boat/login/user_login.action" target="_blank" className='sub_menu'> mhrdnats </NavDropdown.Item>
                  <NavDropdown.Item href="https://www.ncs.gov.in/" target="_blank">ncs</NavDropdown.Item>
                </NavDropdownMenu>
              </Nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
const mapStateToProps = state => {

  // console.log('123apply', state)
  const { user } = state.Login
  return { user }
}

export default withRouter(
  connect(mapStateToProps, { loginSuccess })(BasicExample)
)
